import { environment } from '../../environment.ts';
import {
  AuthConnectPath,
  AuthConnectRequest,
  AuthConnectResponse,
  AuthPayloadPath,
  AuthPayloadRequest,
  AuthPayloadResponse,
  AuthWaitlistPath,
  AuthWaitlistRequest,
} from '@/api/spec.ts';
import { captureError } from '../../utils/sentryHelpers';

const postTemplate = {
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};

export const fetchAuthPayload = async (request: AuthPayloadRequest): Promise<AuthPayloadResponse> => {
  const response = await fetch(`${environment.apiUrl}${AuthPayloadPath}`, {
    ...postTemplate,
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    const error: any = new Error(`Error fetching auth payload: ${response.status}`);
    error.response = { status: response.status };
    throw error;
  }

  return response.json();
};

export const authoriseSignature = async (request: AuthConnectRequest): Promise<AuthConnectResponse> => {
  const response = await fetch(`${environment.apiUrl}${AuthConnectPath}`, {
    ...postTemplate,
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    const error: any = new Error(`Error authorizing signature: ${response.status}`);
    error.response = {
      status: response.status,
      data: await response.json().catch(() => null),
    };
    throw error;
  }

  return response.json();
};

export const submitToWaitlist = async (request: AuthWaitlistRequest): Promise<{ success: boolean; message?: string }> => {
  try {
    const response = await fetch(`${environment.apiUrl}${AuthWaitlistPath}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(request),
    });

    if (response.ok) {
      return { success: true };
    } else {
      const errorData = await response.json().catch(() => ({}));
      return { success: false, message: errorData.error || `Request failed with status ${response.status}` };
    }
  } catch (error: any) {
    console.error('Waitlist submission failed:', error);
    captureError(error, 'waitlist_submission');
    return { success: false, message: error.message || 'An unknown error occurred.' };
  }
};
